import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getDashboard = async () => {
  const response = await axios.get(`${base_url}dashboard/admin`, getAuthHeaders());

  return response.data;
};

const dashboardService = {
  getDashboard,
};

export default dashboardService;
